import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();

export class ZIDXAccountWixSite implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountWixSiteContainer";
    }


    render() {
        // console.log("wix site");
        let self=this;

    }
}